import { RouterProvider } from 'react-router-dom';
import { router } from './router';

/**
 * 应用根组件：只负责挂路由。
 * Provider（Query / 会话引导）在 `Providers` 里，主题在 `main.tsx` 里初始化。
 */
export function App() {
  return <RouterProvider router={router} />;
}
